import { CustomTextField } from '../../components/Inputs';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export function UserFields({ formData, handleInputChange, fieldErrors }) {
  const { t } = useTranslation();

  return (
    <>
      <CustomTextField
        label={t('userFields.userEmail')}
        variant="outlined"
        margin="normal"
        readOnly={true}
        value={formData.correuElectronicUsuari}
      />
      <CustomTextField
        label={t('userFields.password')}
        variant="outlined"
        type="password"
        margin="normal"
        value={formData.contrasenya}
        onChange={(e) => handleInputChange('contrasenya', e.target.value)}
      />
      <CustomTextField
        label={t('userFields.repeatPassword')}
        variant="outlined"
        type="password"
        margin="normal"
        value={formData.repetirContrasenya}
        onChange={(e) => handleInputChange('repetirContrasenya', e.target.value)}
        error={!!fieldErrors.repetirContrasenya}
        helperText={<Typography variant="caption" color="error" ml="18px">{fieldErrors.contrasenya}</Typography>}
      />
    </>
  );
}
